<template>
    <Navigation/>
    <div class="payment">
        <div class="cardContent">
            <div class="card">
                <h1>会员加速卡</h1>
                <ul>
                    <li>用&#12288;户：{{ info.name }}</li>
                    <li>账&#12288;号：{{ info.id }}</li>
                    <li>有效期：1年</li>
                    <li>价&#12288;格：￥{{ this.amount }}</li>
                </ul>
            </div>

            <div class="agreementLine">
                <p>支付即同意</p>
                <a href="/agreements/?id=1" target="_blank">《会员协议》</a>
            </div>
            
            <div class="payTypeContent">
                <button id="alipay_log" v-on:click.prevent="aliPay" :disabled="false">
                    <img src="@/assets/images/alipay_log.png" alt="logo">
                    支付宝支付
                </button>
                <div id="gapLine"></div>
                <button id="wechatpay_log"   v-on:click.prevent="wechatPay" :disabled="false">
                    <img src="@/assets/images/weixin_pay_logo.png" alt="logo" id="weixin_pay_logo">
                    微信支付
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import axios from 'axios';

export default {
    name: 'PaymentView',
    components: {
        Navigation
    },

    data: function(){
        return{
            info: {},
            amount: ''
        }
    },

    computed:{
        user_id(){
            return this.$route.params.user_id
        }
    },

    mounted(){
         this.getUser(this.user_id)
         this.getAmount()
    },

    methods:{
        getUser(user_id){
            let url = `/api/user/${user_id}`;            
            axios
                .get(url)
                .then(response => {
                    this.info = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        getAmount(){
            axios
                .get('/api/alipay/pay_amount')
                .then(response => {
                    this.amount = response.data
                })
                .catch(error => {
                    console.log(error);
                });
        },
        
        aliPay(){            
            let url = `/api/alipay/${this.user_id}`;
            axios
                .get(url)
                .then(response => {
                    window.location.href = response.data;
                })
                .catch(error => {
                    console.log("支付失败:", error);
                })
        },

        wechatPay(){
            alert('暂不支持微信支付')
        }
    }
}
</script>

<style>

.payment{
    width: fit-content;
    margin: 48px auto;
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 18px;
}

.cardContent{
    margin-top: 72px;
    gap: 24px;
}

.card{
    position: relative;
    width: 480px;
    height: 300px;
    background: linear-gradient(to top right, #3A9A9A, #6BCFCF);
    border-radius: 20px;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.4);
}

.card h1{
    padding-top: 24px;
    padding-left: 48px;
    color: white;
    font-size: 48px;
    user-select: none;
}

.card ul{
    padding: 8px;
    padding-left: 48px;
}

.card li{
    line-height: 24px;
    color: white;
    list-style: none;
    z-index: 1;
    user-select: none;
}

.agreementLine{
    display: flex;
    flex-direction: row;
    width: fit-content;
    margin: 24px auto;
}

.agreementLine a{
    display: inline-block;
    text-decoration: none;
    color: #45B5B5;
}

.agreementLine p{
    display: inline-block;
    color: gray;
}

.agreementLine a:hover{
    color: black;
}

.payTypeContent{
    width: fit-content;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
}

.payTypeContent button{
    width: 90px;
    height: 90px;
    display: flex;
    background-color: white;
    border: none;
    flex-direction: column;
    text-align: center;
    width: fit-content;
    text-decoration: none;
    color: gray;
    margin: 0 24px;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
}

.payTypeContent button:hover{
    background-color: rgb(240, 240, 240);
}

#gapLine{
    width: 1px;
    height: 72px;
    margin: auto 0;
    background-color: lightgray;
}

.payTypeContent img{
    margin: 0 auto;
    height: 48px;
}

</style>
